// Turn pasted in-app URLs into chat attachment cards (Slack-style unfurl).
// Cards carry their own org_id/project_id so they deep-link correctly from
// DMs and from other projects.
import { API, HOST } from '@/utils/http'

const MAX_UNFURLS = 3
const URL_RE = /https?:\/\/[^\s<>"')]+/g

export async function cardsFromText(text, router, store) {
  if (!text || !text.includes('://')) return []
  const urls = [...new Set(text.match(URL_RE) || [])].slice(0, MAX_UNFURLS)
  const cards = []
  for (const raw of urls) {
    const card = await cardFromAppUrl(raw, router, store).catch(() => null)
    if (card) cards.push(card)
  }
  return cards
}

export async function cardFromAppUrl(urlString, router, store) {
  let url
  try {
    url = new URL(urlString)
  } catch {
    return null
  }
  if (url.origin !== window.location.origin) return null

  const resolved = router.resolve(url.pathname + url.search)
  const name = resolved?.name
  const params = resolved?.params || {}
  const query = resolved?.query || {}
  const orgId = params.org_id ? Number(params.org_id) : undefined
  const projectId = params.project_id ? Number(params.project_id) : undefined
  if (!projectId) return null

  if (params.featureCode) {
    const feature = await API({ method: 'GET', url: `${HOST}/geo/feature/${params.featureCode}` })
      .then((r) => r.data)
      .catch(() => null)
    const props = feature?.properties || {}
    return {
      type: 'feature',
      feature_code: params.featureCode,
      name: props.name || feature?.name || 'Feature',
      feature_type: props.type || feature?.type || undefined,
      org_id: orgId,
      project_id: projectId,
    }
  }

  if (name === 'ProjectMonitoring' && query.metric) {
    return {
      type: 'metric',
      metric: String(query.metric),
      title: String(query.metric),
      unit: '',
      value: '',
      color: '#0ea5e9',
      points: [],
      org_id: orgId,
      project_id: projectId,
    }
  }

  if (typeof name === 'string' && name.startsWith('Project')) {
    const known = (store.getters['project/getProjects'] || []).find(
      (p) => Number(p.project_id) === projectId
    )
    return {
      type: 'project',
      project_id: projectId,
      org_id: orgId,
      name: known?.project_name || 'Project',
      emoji: known?.emoji || undefined,
      description: known?.project_desc ? String(known.project_desc).slice(0, 200) : undefined,
    }
  }

  return null
}
